import React, { Component } from "react";
import { slide as BurgerMenu } from "react-burger-menu";
import { Menu, Button, Container } from "semantic-ui-react";
import { connect } from "react-redux";
import { withFirebase } from "react-redux-firebase";
import { NavLink, Link, withRouter } from "react-router-dom";
import SignedOutMenu from "../Menus/SignedOutMenu";
import SignedInMenu from "../Menus/SignedInMenu";
import { openModal } from "../../../features/modals/modalActions";

const actions = {
    openModal
};

const mapState = state => ({
    auth: state.firebase.auth,
    profile: state.firebase.profile
});

class BurgerNavbar extends Component {
    state = {
        windowHeight: undefined,
        windowWidth: undefined
    };

    handleResize = () =>
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth / 2
        });

    componentDidMount() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleSignIn = () => {
        this.props.openModal("LoginModal");
    };

    handleRegister = () => {
        this.props.openModal("RegisterModal");
    };

    handleSignOut = () => {
        this.props.firebase.logout();
        this.props.history.push("/");
    };

    render() {
        const { auth, profile } = this.props;
        const authenticated = auth.isLoaded && !auth.isEmpty;
        return (
            <BurgerMenu width={"50%"} disableAutoFocus>
                <Menu
                    inverted
                    stackable
                    style={{
                        width: this.state.windowWidth,
                        marginTop: "-50px",
                        marginLeft: "-50px"
                    }}
                >
                    <Container>
                        {/* <Menu.Item header as={Link} to="/">
                            <img src="/assets/logo.png" alt="logo" />
                            Brand-Name
                        </Menu.Item> */}
                        <Menu.Item
                            as={NavLink}
                            to="/category"
                            name="Category"
                        />
                        {authenticated && (
                            <Menu.Item
                                as={NavLink}
                                to="/experiment"
                                name="experiment"
                            >
                                {/* <Button
                                    floated="right"
                                    positive
                                    inverted
                                    content="Data Input"
                                /> */}
                            </Menu.Item>
                        )}

                        {authenticated ? (
                            <SignedInMenu
                                auth={auth}
                                profile={profile}
                                signOut={this.handleSignOut}
                            />
                        ) : null}
                    </Container>
                </Menu>
            </BurgerMenu>
        );
    }
}

export default withRouter(
    withFirebase(
        connect(
            mapState,
            actions
        )(BurgerNavbar)
    )
);
